import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "accordion",
  id: "pricingAccordion"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["data-bs-target", "aria-controls"]
const _hoisted_4 = { class: "title-group w-100" }
const _hoisted_5 = { class: "day-header-display" }
const _hoisted_6 = { class: "accordion-action-icons actions-group d-flex ms-auto" }
const _hoisted_7 = ["onClick", "data-bs-toggle", "disabled"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["id", "aria-labelledby"]
const _hoisted_11 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingAllDaysStrategyComponent = _resolveComponent("PricingAllDaysStrategyComponent")!
  const _component_PricingWeekStrategyComponent = _resolveComponent("PricingWeekStrategyComponent")!
  const _component_PricingHourStrategyComponent = _resolveComponent("PricingHourStrategyComponent")!
  const _component_CopyPriceWindowModal = _resolveComponent("CopyPriceWindowModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricingWindows, (window, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "accordion-item"
      }, [
        _createElementVNode("h2", {
          class: "accordion-header",
          id: 'heading' + index
        }, [
          _createElementVNode("button", {
            class: "accordion-button d-flex align-items-center justify-content-between",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": '#collapse' + index,
            "aria-expanded": "true",
            "aria-controls": 'collapse' + index
          }, [
            _createElementVNode("span", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("i", {
                class: "fa fa-calendar",
                "aria-hidden": "true"
              }, null, -1)),
              _createElementVNode("strong", null, _toDisplayString(window.name), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(window.daysIn) + " - " + _toDisplayString(window.daysOut) + " Days Out", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("i", {
                role: "button",
                class: _normalizeClass(["fa fa-copy fa-lg action-icon", {
                'action-icon--disabled': !_ctx.currentStrategy.isMultipleWindows,
              }]),
                onClick: _withModifiers(($event: any) => (
                _ctx.currentStrategy.isMultipleWindows && _ctx.copyPricingWindow(window)
              ), ["stop"]),
                "data-bs-toggle": _ctx.currentStrategy.isMultipleWindows && 'modal',
                "data-bs-target": "#copyPriceWindowModal",
                disabled: !_ctx.currentStrategy.isMultipleWindows
              }, null, 10, _hoisted_7), [
                [_directive_tooltip, {
                content: '<center>Copy Price Windows <br/> Settings </center>',
                placement: 'bottom',
                triggers: ['hover'],
                html: true,
              }]
              ]),
              _createElementVNode("i", {
                role: "button",
                class: "fa fa-save fa-lg action-icon ms-2",
                onClick: _withModifiers(($event: any) => (_ctx.savePricingStrategy(window)), ["stop"])
              }, null, 8, _hoisted_8),
              _createElementVNode("i", {
                role: "button",
                class: _normalizeClass(["fa fa-trash-o fa-lg action-icon ms-2", {
                'action-icon--disabled': !_ctx.currentStrategy.isMultipleWindows,
              }]),
                onClick: _withModifiers(($event: any) => (
                _ctx.currentStrategy.isMultipleWindows && _ctx.deletePricingWindow(window)
              ), ["stop"])
              }, null, 10, _hoisted_9)
            ])
          ], 8, _hoisted_3)
        ], 8, _hoisted_2),
        _createElementVNode("div", {
          id: 'collapse' + index,
          class: "accordion-collapse collapse show",
          "aria-labelledby": 'heading' + index,
          "data-bs-parent": "#pricingAccordion"
        }, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.strategyType === 1)
              ? (_openBlock(), _createBlock(_component_PricingAllDaysStrategyComponent, {
                  key: 0,
                  windowProp: window,
                  getUtilizationPrice: _ctx.getUtilizationPrice,
                  getUsePercent: _ctx.getUsePercent,
                  updateUtilizationPrice: _ctx.updateUtilizationPrice,
                  updateUsePercent: _ctx.updateUsePercent,
                  currentStrategy: _ctx.currentStrategy,
                  utilizationPricesByWindowId: _ctx.utilizationPricesByWindowId,
                  handlePricingSaveSuccess: _ctx.handlePricingSaveSuccess,
                  handlePricingSaveError: _ctx.handlePricingSaveError,
                  dailyUtilizationSettingsRef: 
              _ctx.dailyUtilizationSettingsRefs[index]
            ,
                  "onUpdate:dailyUtilizationSettingsRef": ($event: any) => ((
              _ctx.dailyUtilizationSettingsRefs[index]
            ) = $event),
                  invalidDaysIn: _ctx.invalidDaysIn,
                  invalidDaysOut: _ctx.invalidDaysOut,
                  daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut,
                  invalidName: _ctx.invalidName,
                  onUpdateWindow: _ctx.handleUpdateWindow
                }, null, 8, ["windowProp", "getUtilizationPrice", "getUsePercent", "updateUtilizationPrice", "updateUsePercent", "currentStrategy", "utilizationPricesByWindowId", "handlePricingSaveSuccess", "handlePricingSaveError", "dailyUtilizationSettingsRef", "onUpdate:dailyUtilizationSettingsRef", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onUpdateWindow"]))
              : _createCommentVNode("", true),
            (_ctx.strategyType === 2)
              ? (_openBlock(), _createBlock(_component_PricingWeekStrategyComponent, {
                  key: 1,
                  windowProp: window,
                  getUtilizationPrice: _ctx.getUtilizationPrice,
                  getUsePercent: _ctx.getUsePercent,
                  updateUtilizationPrice: _ctx.updateUtilizationPrice,
                  updateUsePercent: _ctx.updateUsePercent,
                  daysOfWeek: _ctx.daysOfWeek,
                  utilizationPricesByWindowId: _ctx.utilizationPricesByWindowId,
                  handlePricingSaveSuccess: _ctx.handlePricingSaveSuccess,
                  handlePricingSaveError: _ctx.handlePricingSaveError,
                  currentStrategy: _ctx.currentStrategy,
                  dailyUtilizationSettingsRef: 
              _ctx.dailyUtilizationSettingsRefs[index]
            ,
                  "onUpdate:dailyUtilizationSettingsRef": ($event: any) => ((
              _ctx.dailyUtilizationSettingsRefs[index]
            ) = $event),
                  invalidDaysIn: _ctx.invalidDaysIn,
                  invalidDaysOut: _ctx.invalidDaysOut,
                  daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut,
                  invalidName: _ctx.invalidName,
                  onUpdateWindow: _ctx.handleUpdateWindow,
                  onSeasonUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('season-updated')))
                }, null, 8, ["windowProp", "getUtilizationPrice", "getUsePercent", "updateUtilizationPrice", "updateUsePercent", "daysOfWeek", "utilizationPricesByWindowId", "handlePricingSaveSuccess", "handlePricingSaveError", "currentStrategy", "dailyUtilizationSettingsRef", "onUpdate:dailyUtilizationSettingsRef", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onUpdateWindow"]))
              : _createCommentVNode("", true),
            (_ctx.strategyType === 3)
              ? (_openBlock(), _createBlock(_component_PricingHourStrategyComponent, {
                  key: 2,
                  windowIndex: index,
                  initialData: _ctx.utilizationPricesByWindowId[window.id as number],
                  priceWindowId: window.id,
                  invalidDaysIn: _ctx.invalidDaysIn,
                  invalidDaysOut: _ctx.invalidDaysOut,
                  daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut,
                  invalidName: _ctx.invalidName,
                  onAddUtilizationPrice: _ctx.handleAddUtilizationPrice,
                  onUpdateInitialData: ($event: any) => (
              _ctx.handleUpdateUtilizationPrices(window.id ?? 0, $event)
            ),
                  onSaveSuccess: _ctx.handlePricingSaveSuccess,
                  onSaveError: _ctx.handlePricingSaveError,
                  ref_for: true,
                  ref: _ctx.getHourlyUtilizationRef(index),
                  currentStrategy: _ctx.currentStrategy,
                  windowProp: window,
                  onUpdateWindow: _ctx.handleUpdateWindow
                }, null, 8, ["windowIndex", "initialData", "priceWindowId", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onAddUtilizationPrice", "onUpdateInitialData", "onSaveSuccess", "onSaveError", "currentStrategy", "windowProp", "onUpdateWindow"]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_10)
      ]))
    }), 128)),
    _createVNode(_component_CopyPriceWindowModal, {
      pricingWindows: _ctx.pricingWindows,
      pricingWindow: _ctx.selectedPricingWindow,
      strategyType: _ctx.strategyType,
      onPriceWindowCopied: _ctx.onPriceWindowCopied
    }, null, 8, ["pricingWindows", "pricingWindow", "strategyType", "onPriceWindowCopied"])
  ]))
}